// extracted by mini-css-extract-plugin
module.exports = {"section":"_1RYiR","title":"_3Cfl8","channel":"_1ZUzh","text":"_1RZFN","line":"_2SjXy","date":"_2OSc3"};